// extracted by mini-css-extract-plugin
export default {"title":"Login_title__JkaQw","link":"Login_link__GY3a8"};